export const reports = {
  All_reports: "All reports",
  Areas_for_Improvement: "Areas for Improvement",
  Assessment: "Assessment",
  Assessment_of_Conformity: "Assessment of Conformity",
  Assessment_Detail_Report_Link: "Link to Assessment Detail Report",
  Conformity_Level: "Conformity Level",
  Conformity_levels_may_have_been_adjusted:
    "Please note that the conformity levels in this standard summary report may have been adjusted to meet each standard organization’s guideline, which may result in a different conformity level than originally assessed.",
  aggregate_levels: {
    label: "Aggregate conformity level to",
    requirement: "Requirement",
    sub_section: "Sub-Section",
    section: "Section",
  },
  custom_report: {
    Add_report_name: "Add report name",
    aggregated: "Aggregated",
    Are_you_sure_you_want_to_delete_report: "Are you sure you want to delete this report?",
    Are_you_sure_you_want_to_modify_report_name: "Are you sure you want to modify the report name?",
    Conformity_level: "Conformity level",
    Create_Custom_Report: "Create custom report",
    Download_entire_table: "Download entire table",
    "Download_filtered_&_customized_table": "Download filtered & customized table",
    Export_to_file: "Export to file",
    Name_cannot_be_empty: "Name cannot be empty",
    Please_define_data_for_your_custom_report: "Please define data for your custom report",
    Report_name: "Report name",
    requirement: "Requirement",
    section: "Section",
    section_ref: "Section ref",
    Select_an_assessment: "Select an assessment",
    Select_sites_and_facilities: "Select sites and facilities",
    Select_standards: "Select standards",
    standard_name: "Standard name",
    standard_reference: "Standard reference",
    sub_section: "Sub section",
    sub_section_ref: "Sub section ref",
    This_action_cannot_be_undone: "This action cannot be undone",
    This_file_will_contain_report_based_on_all_the_customizations_and_filters_you_have_applied:
      "This file will contain report based on all the customizations and filters you have applied",
    This_file_will_contain_whole_report: "This file will contain whole report",
    Use_this_window_to_create_multi_site_multi_standard_report:
      "Use this window to create a multi-site, multi-standard report",
  },
  Custom_Reports: "Custom Reports",
  Customize_table: "Customize table",
  Download_entire_report: "Download entire report",
  Download_filtered_customized_report: "Download filtered & customized report",
  Download_report: "Download report",
  Evidence: "Evidence",
  Evidence_Description: "Evidence Description",
  filteredRecords_Results: "{{filteredRecords}} Results",
  Group_by: "Group by",
  Group_by_assessment: "Group by assessment",
  Group_by_site: "Group by site",
  In_progress: "In progress",
  Internal_audit_required: "Internal audit",
  IRMA_Achievement_Level: "IRMA Achievement Level",
  Please_select_the_preferred_format: "Please select the preferred format",
  Protocol_ID: "Protocol ID",
  Protocol_Question: "Protocol Question",
  Reference: "Reference",
  Reports: "Reports",
  Requirement: "Requirement",
  Reset_to_default: "Reset to default",
  Section: "Section",
  Section_ref: "Section ref",
  Site_name: "Site name",
  Stakeholder_approval_required: "Stakeholder Engagement",
  Standard: "Standard",
  Standard_Reference: "Standard Reference",
  Status: "Status",
  Sub_Section: "Sub Section",
  Sub_Section_Ref: "Sub Section Ref",
  Sub_Theme: "Sub Theme",
  Table_customization: "Table customization",
  Theme: "Theme",
  This_assessment_is_in_progress_The_assessment_data_you_are_viewing_are_subject_to_change:
    "This assessment is in progress. The assessment data you are viewing are subject to change.",
  This_report_will_contain_all_protocol_questions_for_title_for_siteName:
    "This report will contain all protocol questions for {{- title}} for {{- siteName}}.",
  This_report_will_contain_protocol_questions_for_title_for_siteName_based_on_all_the_customizations_and_filters_you_have_applied:
    "This report will contain protocol questions for {{- title}} for {{- siteName}} based on all the customizations and filters you have applied",
  totalRecords_Results: "{{totalRecords}} Results",
} as const;
